import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import FormDialog, { Text } from '../../components/Datatable/FormDialog';
import { Box, Button, IconButton, Snackbar, TextField, Tooltip, Typography, setRef } from '@mui/material';
import { create, get_one, update, delete_one } from '../../services/api';
import EditIcon from '@mui/icons-material/Edit';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import { useFormError } from '../../components/Datatable/FormErrorProvider';
import { RemoveCircleOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../components/AuthProvider';

export default function Group() {
    const notify = useNotify()
    const auth = useAuth()
    const [formState, setFormState] = useState({
        open: false,
        id: null,
    })
    const [ refresh, setRefresh ] = useState(false)
    React.useEffect(() => {
        document.title = "IPV7 Tools - Gate NAS"
      }, [])
    return (
        <>
            <FormItem
                open={formState.open}
                id={formState.id}
                handlerClose={() => setFormState({ open: false, id: null })}
                handlerSubmit={() => setRefresh(true)}
                btnSubmit={formState.id ? 'Atualizar' : 'Salvar'}
                btnClose={'Fechar'}
            ></FormItem>
            <Datatable
                refresh={refresh}
                handlerRefresh={()=>setRefresh(!refresh)}
                title='NAS'
                endpoint='/nas'
                options={{
                    customToolbar: () =>
                        <>
                            <Tooltip title="Remover todos os filtros">
                                <IconButton onClick={() => { localStorage.removeItem('alarms'); location.reload() }} >
                                    <RemoveCircleOutline />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Adicionar">
                                <IconButton disabled={!auth.hasPerm("nas.create")}
                                    onClick={() => setFormState({ open: true, id: null })}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => ""
                }
                }
                columns={[
                    {
                        name: 'id',
                        label: 'ID',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'description',
                        label: 'Descrição',
                    },
                    {
                        name: 'nasname',
                        label: 'IP/Faixa de Origem',
                    },
                    {
                        name: 'shortname',
                        label: 'Apelido',
                    },
                    {
                        name: 'secret',
                        label: 'Senha',
                        options:{
                            display: false
                        }
                    },
                    {
                        name: 'actions',
                        label: 'Ações',
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <>
                                        <Tooltip title="Editar">
                                            <IconButton
                                                disabled={!auth.hasPerm("nas.update")}
                                                onClick={() => setFormState({ open: true, id: tableMeta.rowData[0] })}
                                            >
                                                <EditIcon />

                                            </IconButton>
                                        </Tooltip>

                                    </>
                                )
                            }
                        }
                    }
                ]}

            />
        </>
    )
}




function FormItem({ id, open, handlerClose, handlerSubmit, btnClose = 'Fechar', btnSubmit = 'Salvar'}) {
    const notify = useNotify()
    const error = useFormError()
    const auth = useAuth()
    const [isLoaded, setIsLoaded] = useState(true)
    useEffect(() => {
        setState(modelState)
        error.setErrors([])
        if (id) {
            setIsLoaded(false)
            get_one('/nas', id).then(res => {
                setState(res.data.data)
                setIsLoaded(true)
            }).catch(e => {console.log(e)
            setIsLoaded(true)
            })
        }
    }, [id])
    const modelState = {
        nasname: '',
        description: '',
        shortname: '',
        secret: '',

    }
    const [state, setState] = useState(modelState)
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    }

    const wrapperSubmit = () => {
        if (id) {
            update('/nas', id, state).catch(e => notify
                .setNotify({ open: true, message: e.message, severity: 'error' }))
                .then(res => {
                    if (res.data.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }
                    handlerClose()
                    notify.setNotify({ open: true, message: 'NAS atualizado com sucesso', severity: 'success' })
                    error.setErrors([])
                }).catch(e => notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }
        else {
            create('/nas/create', state)
            .then(res => {
                console.log(res)
                if (res.data.errors) {
                    error.setErrors(res.data.errors)
                    return
                }
                handlerClose()
                notify.setNotify({ open: true, message: 'NAS criado com sucesso.', severity: 'success' })
                error.setErrors([])
            })
            .catch(e => 
                notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }
        handlerSubmit()

    }
    return (
        <Box component={"form"}
            onSubmit={wrapperSubmit}
            sx={{ m: 2 }}
            display={'flex'}
            flexWrap={'wrap'}
        >

            <FormDialog
                isLoaded={isLoaded}
                title={
                    <Box display={"flex"} justifyContent={'space-between'}>
                        <Typography variant="h6" component="div">{id ? 'Editar' : 'Adicionar'} NAS</Typography>
                        <IconButton 
                        disabled={!auth.hasPerm("nas.delete")}
                        sx={{ display: id ? 'block' : 'none' }}
                        onClick={()=>{
                             if (confirm('Deseja excluir o NAS?')){
                                    delete_one('/nas', id).then(res => {
                                        notify.setNotify({ open: true, message: 'NAS deletado com sucesso.', severity: 'success' })
                                        handlerClose()
                                        handlerSubmit()
                                    })
                             }
                        }}>
                            <DeleteIcon/>
                        </IconButton>
                    </Box>
                }
                open={open}
                handlerSubmit={wrapperSubmit}
                handlerClose={handlerClose}
                btnSubmit={btnSubmit}
                btnClose={btnClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                    <TextField
                        sx={{ mb: 2, mt: 2 }}
                        error={error.verify('nasname')}
                        helperText={error.msgError('nasname')}
                        label='IP/Faixa de Origem'
                        value={state.nasname}
                        name={'nasname'}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify("description")}
                        helperText={error.msgError("description")}
                        label='Descrição'
                        name={"description"}
                        value={state.description}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('shortname')}
                        helperText={error.msgError('shortname')}
                        label='Apelido'
                        name={'shortname'}
                        value={state.shortname}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('secret')}
                        helperText={error.msgError('secret')}
                        label='Senha'
                        name={'secret'}
                        value={state.secret}
                        onChange={handleChange}
                    />
                   
                </Box>

            </FormDialog>
        </Box>
    )
}


